import { Component, OnInit, Output, EventEmitter, Input, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy, Version, OnChanges, SimpleChanges } from '@angular/core';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';

import { ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject, Subscription } from 'rxjs';

import { TreeService, Constants } from '@usimweb/core/services';

import { Versions, TreeNode } from '@usimweb/core/models';

// import { TreeType } from '../../../../core/enums/treeTypeEnum';

import { Store } from '@ngrx/store';
import * as fromStore from '@usimweb/state/store';

export enum TreeType {
  INPUT_TREE = 'inputTree',
  VERSION_TREE = 'versionTree',
  NO_VERSION_TREE = 'noVersionTree',
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'usimweb-treeview',
  templateUrl: './treeview.component.html',
  styleUrls: ['./treeview.component.scss'],
  standalone: false,
})
export class TreeviewComponent implements OnInit, OnDestroy, OnChanges {
  @Input() versions!: Versions[];

  @Input() version_uuid: string = '';

  @Output() showRunEmitter: EventEmitter<string> = new EventEmitter<string>();

  @Output() openDialogEvent: EventEmitter<any> = new EventEmitter<any>();

  private versionByIdSub$!: Subscription;
  private velaInputSub$!: Subscription;
  private allVersionsSub$!: Subscription;

  public treeControl = new NestedTreeControl<TreeNode>((node) => node.children);
  public dataSource!: MatTreeNestedDataSource<TreeNode>;
  public hasChild = (_: number, node: TreeNode) => !!node.children && node.children.length > 0;

  public treeType = TreeType;

  public progressVersions = false;

  constructor(
    private treeService: TreeService,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private store: Store<fromStore.DashboardState>,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.version_uuid = this.route.snapshot.paramMap.get('id2')?.toString() || '';
    if (this.version_uuid) {
      this.velaInputSub$ = this.store.select(fromStore.getVelaInput).subscribe((velaInput) => {
        //console.log('called sub getVelaInput if versions');
        this.dataSource = this.treeService.initTree(velaInput);

        this.versionByIdSub$ = this.store.select(fromStore.getVersionsById(this.version_uuid)).subscribe((version) => {
          //console.log('called sub getVersionsById');
          //console.log(version);
          if (version) {
            //this.dataSource = this.treeService.initTree(version.vela?.input_value as any);
            const history = version.history;
            if (history) {
              this.updateVersions(history);
            }
          }
        });
      });
    } else {
      this.velaInputSub$ = this.store.select(fromStore.getVelaInput).subscribe((velaInput) => {
        //console.log('called sub getVelaInput if no');
        this.dataSource = this.treeService.initTree(velaInput);
        this.progressVersions = true;
        this.cd.detectChanges();

        this.allVersionsSub$ = this.store.select(fromStore.getAllVersions).subscribe((versions) => {
          this.updateVersions(versions);
        });

        //FIXME why 2nd update?
        if (this.versions) {
          this.updateVersions(this.versions);
        }
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['version_uuid'] && this.version_uuid) {
      this.version_uuid = this.version_uuid;
      this.allVersionsSub$ = this.store.select(fromStore.getAllVersions).subscribe((versions) => {
        const version = versions.filter((x) => x.uuid === this.version_uuid)[0];
        if (version && version.vela?.input_value) {
          this.dataSource = this.treeService.initTree(version.vela?.input_value as any);
          this.updateVersions(version.history as any);
        }
      });
    }
  }

  public ngOnDestroy(): void {
    if (this.versionByIdSub$) {
      this.versionByIdSub$.unsubscribe();
    }

    if (this.velaInputSub$) {
      this.velaInputSub$.unsubscribe();
    }

    if (this.allVersionsSub$) {
      this.allVersionsSub$.unsubscribe();
    }
  }

  // dialog to update value in tree
  public openCategoryDialog(treeNode: TreeNode) {
    if (treeNode.data?.length === 0) {
      return;
    }

    let index = -1;
    let key = treeNode.name;
    if ('index' in treeNode && treeNode.part) {
      index = treeNode.index || 0;
      key = treeNode.part;
    }

    console.log('treenode');
    console.log(treeNode);

    this.treeService.highLight(treeNode);

    const data = { event: 'category', index: index, key: key, treeNode: treeNode };
    this.openDialogEvent.emit(data);
    //this.treeService.handleDialog(treeNode);
  }

  public addActor(treeNode: TreeNode) {
    console.log('treenode');
    console.log(treeNode);
    if (treeNode.data) {
      const data = { event: 'addActor', treeNode: treeNode };
      this.openDialogEvent.emit(data);
      //this.treeService.handleCategory(treeNode.data[0] as VelaInput, treeNode.name, treeNode.index || 0);
    }
  }

  public getPartKey(treeNode: TreeNode) {
    if (treeNode.data?.length === 0) {
      return 'noPart';
    }
    return treeNode.name.trim();
  }

  public getNewPartKey(treeNode: TreeNode) {
    return treeNode.name;
  }

  public getDefaultPartKey(treeNode: TreeNode) {
    return 'default_' + treeNode.name;
  }

  public getPartToggleKey(treeNode: TreeNode) {
    return 'toggle_' + treeNode.name;
  }

  public getDeleteKey(treeNode: TreeNode) {
    return 'delete_' + treeNode.name;
  }

  public deleteActor(treeNode: TreeNode) {
    this.treeService.delete(treeNode, this.store, fromStore);
    this.snackBar.open(Constants.General.RM_SIM_SETUP, Constants.General.OK, { duration: 2000 });
  }

  public showSim(treeNode: TreeNode) {
    if (this.versions.length > 0) {
      const version = treeNode.data as unknown as Versions;
      this.version_uuid = version.uuid;
      this.showRunEmitter.emit(version.uuid);
      this.snackBar.open(Constants.General.LOAD_SIM_SETUP + treeNode.name, Constants.General.OK, { duration: 2000 });
      return;
    }
    this.snackBar.open(Constants.General.NO_FIN_SIM, Constants.General.OK, { duration: 2000 });
  }

  public renameSim(treeNode: TreeNode) {
    const version = treeNode.data as unknown as Versions;
    let subject = new Subject<any>();

    const data = { event: 'rename', treeNode: treeNode, inputTree: this.dataSource, subject: subject };
    this.openDialogEvent.emit(data);

    // this.treeService.rename(treeNode, subject);

    // subject.subscribe((result: any[]) => {
    //   this.renameVersionEmitter.emit({ uuid: version.uuid, result: result[1] });
    //   this.snackBar.open(Constants.RENAME_SIM_SETUP, Constants.OK, { duration: 3000 });
    //   // update tree here
    // });
  }

  // update versions in tree
  public updateVersions(versions: Versions[]) {
    this.versions = versions;

    const cpy = this.dataSource.data;
    this.dataSource.data = [];
    this.dataSource.data = this.treeService.updateVersion(cpy, versions);
    this.progressVersions = false;
    this.cd.detectChanges();
  }

  public isMultiObj(treeNode: TreeNode) {
    if (treeNode.name.includes('connection') || treeNode.name.includes('patches') || treeNode.name.includes('heatExchangers')) {
      return true;
    }

    // if (treeNode.children) {
    //   const hasConnections = treeNode.children.some((child) => child.name === 'connections' || child.name === 'patches' || child.name == 'heatExchangers');
    //   if (hasConnections) {
    //     return true;
    //   }

    //   return true;
    // }

    return false;
  }

  public addDefaultActor(treeNode: TreeNode) {
    const data = { event: 'addDefaultActor', treeNode: treeNode };
    this.openDialogEvent.emit(data);
  }

  public isDeleteObj(treeNode: TreeNode) {
    if (treeNode.name && treeNode.index !== undefined && treeNode.index >= 0) {
      if (!treeNode.children && treeNode?.data && !('version' in treeNode.data)) {
        return true;
      }
    }
    return false;
  }

  public showSeparator(treeNode: TreeNode) {
    if (treeNode.name === Constants.General.SIM_SETUP) {
      return true;
    }
    return false;
  }

  public collapse(treeNode: TreeNode) {
    treeNode.collapse = !treeNode.collapse;
  }

  public currentVersion(treeNode: TreeNode) {
    const version = treeNode.data as unknown as Versions;

    if (version) {
      return version.uuid === this.version_uuid ? true : false;
    }
    return false;
  }

  public deleteVersion(treeNode: TreeNode) {
    const version = treeNode.data as unknown as Versions;
    this.treeService.deleteVersion(version, this.store, fromStore);
    this.snackBar.open('Deleted version...', 'OK', { duration: 2000 });
  }

  // public toggleSetup(treeNode: TreeNode, toogle: boolean) {
  //   this.treeService.toggle(treeNode, toogle);
  //   this.treeService.clearTree();

  //   toogle === true
  //     ? this.snackBar.open(Constants.EN_SIM_SETUP, Constants.OK, { duration: 2000 })
  //     : this.snackBar.open(Constants.DS_SIM_SETUP, Constants.OK, { duration: 2000 });

  //   this.treeService.initStruct();
  // }
}
